module.exports = __webpack_public_path__ + "static/media/qr.0807e633.svg";